import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {NzUploadFile} from 'ng-zorro-antd/upload';
import {ImageUtils} from '../../utils/image-utils.class';
import {NotificationService} from "@shared/services/notification.service";
import {InputBoolean} from "ng-zorro-antd/core/util";

export type ImageType = "image/png"|"image/jpeg"|"image/jpg"|"image/ico"|"image/svg+xml";

@Component({
  selector: 'app-upload-image-simple',
  templateUrl: './upload-image-simple.component.html',
  styleUrls: ['./upload-image-simple.component.scss']
})
export class UploadImageSimpleComponent implements OnInit {
  @Input() accept: ImageType[] = ["image/png", "image/jpeg", "image/png", "image/ico", "image/svg+xml"];
  @Input() minSize:number = 0; //MB
  @Input() maxSize:number = 20; //MB
  @Input() maxWidth: number = 10000; //px
  @Input() maxHeight: number = 10000; //px
  @Input() minWidth: number = 10; //px
  @Input() minHeight: number = 10; //px
  @Input() stylePreview = {width: '500px', height: '100%'}
  @Input() imageUrl: string;
  @Input() @InputBoolean() avatar : boolean = false;

  fileList: NzUploadFile[] = [];
  @Output() uploadComplete: EventEmitter<any> = new EventEmitter<any>();
  showIcons = false;
  constructor(
    private notificationService: NotificationService,
  ) { }

  ngOnInit(): void {
  }

  beforeUpload = (file: NzUploadFile) => {
      const isImage = this.accept.includes(file.type as unknown as ImageType);
      if (!isImage) {
        this.notificationService.warning('Chỉ có thể upload ảnh!');
        return false;
      }
      const isMinImgSize = file.size! / 1024 / 1024 >= this.minSize;
      const isMaxImgSize = file.size! / 1024 / 1024 <= this.maxSize;
      if (!isMinImgSize) {
        this.notificationService.warning(`Dung lượng ảnh quá nhỏ. Yêu cầu > ${this.minSize} MB`);
        return false;
      }

      if (!isMaxImgSize) {
        this.notificationService.warning(`Dung lượng ảnh quá lớn. Yêu cầu < ${this.maxSize} MB`);
        return false;
      }

      let isDimension = false;
      ImageUtils.checkImageDimension(file as unknown as File, this.minWidth, this.maxWidth, this.minHeight, this.maxHeight).then(dimensionRes => {
        isDimension = dimensionRes;
        if (!dimensionRes) {
          this.notificationService.warning(
            `Kích thước ảnh yêu cầu ${this.minWidth} x ${this.minHeight} - ${this.maxWidth} x ${this.maxHeight}`,
          );
          return false;
        }
        this.handleUpload(file);
      });

      return false;
  };

  handleUpload = (file: NzUploadFile) => {
    this.remove();
    this.fileList = [file];
    this.uploadComplete.emit(this.fileList[0]);
    this.getBase64(file as unknown as File, (img: string) => {
      this.imageUrl = img;
    });
  }

  remove = () => this.fileList = [];

  getBase64(img: File, callback: (img: string) => void): void {
    const reader = new FileReader();
    reader.addEventListener('load', () => callback(reader.result!.toString()));
    reader.readAsDataURL(img);
  }

  removeImage() {
    this.remove();
    this.imageUrl = null;
    this.showIcons = false;
    this.uploadComplete.emit(null);
  }

  previewImage: string | undefined = '';
  previewVisible = false;
  viewImage() {
    this.previewImage = this.imageUrl;
    this.previewVisible = true;
  }
}
